module.exports = __webpack_public_path__ + "static/media/NG.fe15d89d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/NG.svg
// module id = 2226
// module chunks = 7